export const articlePathToSlugId = (articlePath: string) => {
  const arr = articlePath.split('-');
  const id = arr.pop() || '';
  const slug = arr.join('-');

  return { slug, id };
};
